<template>
    <div v-if="loading" class="flex justify-center p-20">
        <loading-spinner :large="true" />
    </div>
    <component
        v-else
        :is="display"
        v-bind="props"
    />
    <Meta
        title="Catalog | Resources"
        :jsonLdBreadcrumbs="[
            { title: 'Home', url: 'https://www.seclock.com' },
            { title: 'Catalog', url: 'https://www.seclock.com/catalog' },
            { title: 'Resources', url: 'https://www.seclock.com/catalog/resources' }
        ]"
        :jsonLdMainEntity="jsonLdEntity"
        description="View a complete list of our vast collection of resources by manufacturer."
    />
</template>

<script setup>
import {useSettingsLoader, useUser, useJsonLd} from "@/Composables";
import {LoadingSpinner, Meta} from "@/Components";
import MarketingIndex from "@/Themes/Marketing/Pages/Catalog/Resources/Index.vue";
import SourcingIndex from "@/Themes/Sourcing/Pages/Catalog/Resources/Index.vue";
import {ref, computed, onMounted, markRaw} from "vue";

const { jsonLdMainEntityResources } = useJsonLd();

const { settings } = useUser();
const props = defineProps({
    crumbs: {
        type: Array,
        required: true,
    },
    manufacturers: {
        type: Array,
        required: true,
    },
    newCatalogs: {
        type: Array,
        required: true,
    },
    newVideos: {
        type: Array,
        required: true,
    },
    pinnedResources: {
        type: Array,
        required: false,
    },
});

const loading = ref(true);

onMounted(() => {
    try{
        useSettingsLoader().fetchSettings(['resourceSearch']).then(()=> {
            loading.value = false;
        });
    }catch (e) {
        console.log(e);
    }
});

const display = computed(() =>
    settings.value.is_sourcing_mode ? markRaw(SourcingIndex) : markRaw(MarketingIndex)
);

const jsonLdEntity = computed(() => jsonLdMainEntityResources(props.manufacturers));
</script>
